import { Component, OnInit } from '@angular/core';
import { HistoricoConsultaService } from 'src/app/services/http/historico-consulta.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { RelatorioService } from 'src/app/services/http/relatorio.service';

@Component({
  selector: 'app-relatorio-producao',
  templateUrl: './relatorio-producao.component.html',
  styleUrls: ['./relatorio-producao.component.scss']
})
export class RelatorioProducaoComponent implements OnInit {

  show = false;
  tableLoading;
  listaResultado = [];

  clienteSelecionado: any = '';
  pesquisaDataInicio: any;
  pesquisaDataFim: any;

  dataInicio = new Date();
  dataFim = new Date();

  listaUnidades = [];
  pesquisaCliente: any;
  inputClienteFormat = (u) => u.nomeFantasia;

  listaTipo: any[] = [];
  tipoSelecionado = '';

  constructor(private historicoService: HistoricoConsultaService, private unidadeService: UnidadeService, private relatorioService: RelatorioService) {
    let now = new Date();
    this.unidadeService.getListaUnidadeNomeFantasia().then(r => this.listaUnidades = r);
    this.unidadeService.getListaTipoUnidadeCliente().then(t => this.listaTipo = t);

    this.setDataInicio({
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    }, false);

    this.setDataFim({
      day: now.getDate(),
      month: now.getMonth() + 1,
      year: now.getFullYear(),
    }, false);

    this.pesquisaCliente = (text: Observable<string>) =>
      text.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map(term => this.listaUnidades.filter(
          c => (c.nomeFantasia || '').toLowerCase().indexOf(term.toLowerCase()) > -1
        ).slice(0, 10))
      )
  }

  ngOnInit() {
    this.dataInicio.setDate(1);
  }

  setDataInicio(date, update = true) {
    date = this.dataInicio.getTime(),
    this.pesquisaDataInicio = date;
  }

  setDataFim(date, update = true) {
    date = this.dataFim.getTime(),
    this.pesquisaDataFim = date;
  }

  addFiltroCliente(cliente: any) {
    //  this.filter.cliente = cliente.item;
  }

  removeFiltroCliente() {
    //this.filter.cliente = null;
    this.clienteSelecionado = '';
  }

  realizarRelatorio() {
    //this.dataInicio.setDate(this.dataInicio.getDate() - 1);
    const json = {
      dataIntervalo: {
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
      },
      dataComparacao: {
        dataInicio: this.dataInicio,
        dataFim: this.dataFim,
      },
      cliente: {...this.clienteSelecionado},
      tipo: this.tipoSelecionado || 'Selecione'
    }

    this.relatorioService.gerarRelatorioProducao(json).then(r => {
      this.listaResultado = r;

    });

  }

}
